export default __webpack_public_path__ + "static/media/Accensus.16400fda.jpg";